import useSWR from "swr";

import { getJSON } from "@/utils/swr";

const API_URL = `${import.meta.env.VITE_API_HOST}/api/bookings/csrf`;

const useCsrfToken = (profileParam: string | null) => {
  useSWR(
    `${API_URL}${profileParam}`,
    getJSON("", {
      requestOptions: {
        credentials: "include",
      },
    }),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );
};

export default useCsrfToken;
